<script setup lang="ts">
import { mapStores } from 'pinia'
import { defineComponent } from 'vue'
import obraFavoritaService from "@/services/obra-favorita.service"
import FavoritoSelecionado from '@/components/icons/FavIcon.vue'
import FavoritoVazio from '@/components/icons/Fav2Icon.vue'
import Obra from '@/services/model/obra'
import { useObraStore } from '@/stores/obras';
useObraStore();
</script>
<template>
    <div :title="titulo">
        <favorito-selecionado v-if="favorito" @click.stop="desfavoritar" class="obra-favorita-botao" />
        <favorito-vazio v-if="!favorito" @click.stop="favoritar" class="obra-favorita-botao" />
    </div>
</template>

<script lang="ts">
export default defineComponent({
    name: "FavoritarObra",
    components: {
        FavoritoSelecionado,
        FavoritoVazio
    },
    props: {
        obra: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapStores(useObraStore),
        favorito(): boolean {
            return this.obra.favorito;
        },
    },
    data() {
        return {
            titulo: ''
        }
    },
    methods: {
        favoritar() {
            obraFavoritaService.adicionar(this.obra.codLote);
            this.ObraStore.favoritar(this.obra as Obra);
            this.titulo = 'Tornar essa obra favorita e receber notificações';
        },
        desfavoritar() {
            obraFavoritaService.remover(this.obra.codLote);
            this.ObraStore.desfavoritar(this.obra as Obra);            
            this.titulo = 'Remover obra favorita e parar de receber notificações';
        },
    }
})
</script>
<style scoped>
.obra-favorita-botao {
    cursor: pointer;
}
</style>